export default __webpack_public_path__ + "static/media/connect_four_intro.25576553.mp3";